// components/BrandCarousel.jsx
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const brandLogos = [
  'logo_1.png',
  'logo_2.png',
  'logo_3.png',
  'logo_4.png',
  'logo_5.png',
  'logo_6.png',
  'logo_7.png',
  'logo_8.png',
];

const BrandCarousel = () => {
  const { t } = useTranslation();
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h4 className="text-yellow-500 font-semibold uppercase">{t('brand.subtitle')}</h4>
          <div className="w-16 h-1 bg-yellow-500 mx-auto my-2"></div>
          <h2 className="text-3xl md:text-5xl font-bold">{t('brand.title')}</h2>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={2}
          breakpoints={{
            640: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 5 },
          }}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          loop={true}
        >
          {brandLogos.map((logo, index) => (
            <SwiperSlide key={index}>
              <div className="flex justify-center items-center border-2 border-gray-200 p-4">
                <img
                  src={`assets/images/homepage/${logo}`}
                  alt={`Brand ${index + 1}`}
                  className="max-h-40 opacity-[0.7]"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default BrandCarousel;
